/// <reference path="../../BaseNew/GAdmSeznamBase.ts"/>

namespace Gordic.Adm.WebControls {
    @Decorators.gcontent
    export class SeznamTypyDokumentuSchvalovaciSablonyEpk extends GContentBase<SeznamTypyDokumentuSchvalovaciSablonyEpkObj> {
        private seznamObj: SeznamTypyDokumentuSchvalovaciSablonyEpkObj & GContent;

        onContentReady() {
            this.seznamObj = $.extend(this as GContent, new SeznamTypyDokumentuSchvalovaciSablonyEpkObj());
            this.seznamObj.createBase({
                content: this,
                contentName: "seznamTypyDokumentuSchvalovaciSablonyEpkNew",
                contentCaption: "jres:33000905", //RC 33000905 : Přiřazené typy dokumentů schvalovací šabloně EPK
                dataListDescriptor: this.dataListDescription,
                comparatorSettings: {
                    itemTemplate: "{ixs_ssa_txt} - {ixs_typ_txt}"
                },
                gridSettings: {
                    columnOrder: this.getColumnOrder()
                }
            })
            this.seznamObj.createBaseMenuBarActions();
            this.seznamObj.createFilter();
            this.seznamObj.createGrid();
        }

        private getColumnOrder(): string {
            let columnOrder = "";
            if (this.ixs_ssa)
                columnOrder += "ixs_typ_txt,"
            else if (this.ixs_typ)
                columnOrder += "ixs_ssa_txt,"
            else {
                columnOrder += "ixs_typ_txt,ixs_ssa_txt"
            }
            columnOrder += "dat_od,dat_do,dat_zmena,zmenu_prov_txt";
            return columnOrder;
        }
    }

    export class SeznamTypyDokumentuSchvalovaciSablonyEpkObj extends GAdmSeznamBase {
        ixs_ssa: string;
        ixs_typ: string;

        private openFromSablona() {
            return this.ixs_ssa ? true : false
        }

        create() {

        }

        openDetail(data: any, isNew: boolean) {
            const cntInitializer = ["Gordic.Adm.WebControls.DetailTypyDokumentuSchvalovaciSablonyEpk", {
                currentFilter: this.filterData,
                gridRc: new Gordic.Components.GridRC(this.grid),
                openSablona: this.openFromSablona(),
                openDialog: this.tabOpen
            }]
            const inputParams = {
                ID: "DetailTypyDokumentuSchvalovaciSablonyEpk",
                newRecord: isNew,
                ixs_ssa: isNew == true ? (this.ixs_ssa ? this.ixs_ssa : null) : data.ixs_ssa,
                ixs_typ: isNew == true ? (this.ixs_typ ? this.ixs_typ : null) : data.ixs_typ
            }
            this.openDialogOrModalWindow(cntInitializer, inputParams);
        }

        createActions(): { [akceName: string]: GAction | GActionParamsDefObj } | null {
            return null
        }

        createBaseMenuBarActions() {
            this.cnt.menuBar(this.cnt.actions.createBar(["actOpenDetail*", "actNewDetail*", "actAddToComparison*", "actOpenDialogVyberovaSkupina*"]))
        }

        createContextMenu(): MenuParams[] {
            return this.cnt.actions.createBar(["actOpenDetail*", "actOpenDialogVyberovaSkupina*"])
        }

        createFilterForm() {
            this.filterForm.addRow("jres:32131057").addField("gselectbox", Gordic.Prefabs.Select.wflsssa(), { //RC 33000888 : Skupina funkcí
                name: "ixs_ssa",
                model: "model.ixs_ssa=value.ixs_ssa",
                dropdown: true,
                disabled: (this.ixs_ssa) ? true : false
            }).addRow("jres:33000817").addField("gselectbox", Gordic.Prefabs.Select.sslstyp(), {
                name: "ixs_typ",
                model: "model.ixs_typ=value.ixs_typ",
                dropdown: true,
                disabled: (this.ixs_typ) ? true : false
            })
        }

        userhardDefaultFilter(hardFilter: any): any {
            if (this.ixs_ssa)
                hardFilter["ixs_ssa"] = this.ixs_ssa;
            if (this.ixs_typ)
                hardFilter["ixs_typ"] = this.ixs_typ;
            return hardFilter;
        }

        collectData(data: any) {
            if (this.ixs_ssa)
                data["ixs_ssa"] = this.ixs_ssa;
            if (this.ixs_typ)
                data["ixs_typ"] = this.ixs_typ;
        }

        applydata(filterData: any) {
            this.cnt.isl.TypyDokumentuSchvalovaciSablonyEpk.list({ filters: filterData }).getView().then((data) => {
                this.setPlatnostColumn(data)
                this.view = data;
                this.grid.ggrid('setData', this.view);
            });
        }

        selectionGridAct(objArr: IGGridSelection<any>) {

        }

        getSxs(data): IGAdmGridSxs {
            return {
                sxs: `${data.ixs_ssa}#${data.ixs_typ}#`,
                nazev: `${data.ixs_ssa_txt} - ${data.ixs_typ_txt}`
            }
        }
    }
}